/**
 * LNV Newsletter
 * Version: 1.0
 * Purpose: Premium newsletter interactions and reveal animation.
 */

(function () {
  "use strict";

  function initNewsletter(section) {
    if (!section || section.dataset.lnvNewsletterInitialized === "true") {
      return;
    }

    section.dataset.lnvNewsletterInitialized = "true";

    const revealElements = section.querySelectorAll(".lnv-reveal");

    if (!revealElements.length) {
      return;
    }

    /*
     * Respect reduced-motion preferences.
     */
    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (reducedMotion) {
      revealElements.forEach((element) => {
        element.classList.add("lnv-motion-visible");
      });

      return;
    }

    /*
     * If IntersectionObserver is unavailable,
     * reveal everything immediately.
     */
    if (!("IntersectionObserver" in window)) {
      revealElements.forEach((element) => {
        element.classList.add("lnv-motion-visible");
      });

      return;
    }

    /*
     * Hide elements before they enter the viewport.
     */
    revealElements.forEach((element) => {
      element.classList.add("lnv-motion-hidden");
    });

    const observer = new IntersectionObserver(
      (entries, observerInstance) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }

          entry.target.classList.remove("lnv-motion-hidden");
          entry.target.classList.add("lnv-motion-visible");

          observerInstance.unobserve(entry.target);
        });
      },
      {
        threshold: 0.12,
        rootMargin: "0px 0px -40px 0px"
      }
    );

    revealElements.forEach((element) => {
      observer.observe(element);
    });
  }

  function initAllNewsletters(root) {
    const scope = root || document;

    scope
      .querySelectorAll("[data-lnv-newsletter]")
      .forEach(initNewsletter);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAllNewsletters();
  });

  /*
   * Shopify Theme Editor support.
   */
  document.addEventListener("shopify:section:load", function (event) {
    initAllNewsletters(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    const section = event.target;

    if (!section) {
      return;
    }

    delete section.dataset.lnvNewsletterInitialized;
  });
})();